<!--团队业绩-->
<template>
<div style="height:100%">
    <div class="handleBox flex flex-ai-c">
        <el-page-header @back="goBack" :content="title" style="color:#95A1B9"></el-page-header>
        <el-button v-if="type!=1 && type != 5" type="success" size="small" style="margin-left:auto">总金额：{{total}}元</el-button>
        <el-button v-if="type!=1 && type != 5" type="warning" size="small" style="margin-left:5px" @click="exportFun()">导出</el-button>
    </div>

    <!-- 表格 -->
    <div class="tabSwitch">
        <el-tabs v-model="type" :stretch="true" @tab-click="handleClick">
            <el-tab-pane label="个人详细信息" name="1"></el-tab-pane>
            <el-tab-pane label="消费记录" name="2"></el-tab-pane>
            <el-tab-pane label="分销结算" name="3"></el-tab-pane>
            <el-tab-pane label="提现记录" name="4"></el-tab-pane>
            <el-tab-pane label="上级列表" name="5"></el-tab-pane>
        </el-tabs>
    </div>

    <div class="table" style="height:calc( 100% - 168px );margin-top:8px">
        <el-table v-if="type!=1 && type != 5" ref="multipleTable" :data="list" highlight-current-row stripe height="calc( 100% - 40px )" :cell-style="{color:'#515a6e',borderColor:'#E8EAEC'}" :header-cell-style="{background:'#F8F8F9',color:'#515A6E'}">
            <el-table-column v-if="type == 2" prop="order_num" label="订单号" show-overflow-tooltip></el-table-column>
            <el-table-column v-if="type == 2" prop="name" label="购买产品" show-overflow-tooltip></el-table-column>
            <el-table-column v-if="type == 2" prop="amount" label="金额" show-overflow-tooltip></el-table-column>

            <template v-if="type == 3">
                <el-table-column prop="order_no" label="订单号" show-overflow-tooltip></el-table-column>
                <el-table-column prop="buyer_nickname" label="下单人员" show-overflow-tooltip></el-table-column>
                <el-table-column prop="goods" label="购买商品" show-overflow-tooltip></el-table-column>
                <el-table-column prop="goods_class_name" label="消费类型" show-overflow-tooltip></el-table-column>
                <el-table-column prop="order_amount" label="订单金额" show-overflow-tooltip></el-table-column>
                <el-table-column prop="guan_xi" label="隶属关系" show-overflow-tooltip></el-table-column>
                <el-table-column prop="num" label="贡献值/积分" show-overflow-tooltip></el-table-column>
            </template>

            <el-table-column v-if="type == 4" prop="amount" label="金额" show-overflow-tooltip></el-table-column>
            <el-table-column v-if="type == 4" prop="create_time" label="提现时间" show-overflow-tooltip></el-table-column>
            <el-table-column v-if="type == 2 || type == 3" prop="create_time" label="下单时间" show-overflow-tooltip></el-table-column>
        </el-table>
        
        <el-descriptions v-if="type==1" title="" :column="2" border colon labelClassName="userLabel" contentClassName="userContent">
            <el-descriptions-item label="上级(昵称)">{{userForm.parent ? userForm.parent.nickname : ''}}</el-descriptions-item>
            <el-descriptions-item label="上级职位">{{userForm.parent ? userForm.parent.tuan_level_name : '-'}}</el-descriptions-item>
            <el-descriptions-item label="本人营销职级">
                <span>会员区:{{userForm.vip_level}}</span> | <span>自营区:{{userForm.zi_level_name}}</span>
            </el-descriptions-item>
            <el-descriptions-item label="上级营销职级">
                <span>会员区:{{userForm.parent?userForm.parent.vip_level:'-'}}</span> | <span>自营区:{{userForm.parent?userForm.parent.zi_level_name:'-'}}</span>
            </el-descriptions-item>
            <el-descriptions-item label="用户身份">{{userForm.user_level_name}}</el-descriptions-item>
            <el-descriptions-item label="注册时间">{{userForm.create_time}}</el-descriptions-item>
            <el-descriptions-item label="团队业绩(元)">{{userForm.team_sum}}</el-descriptions-item>
            <el-descriptions-item label="提现总额(元)">{{userForm.withdrawed}}</el-descriptions-item>
            <el-descriptions-item label="贡献值余额">{{userForm.jin_dou}}</el-descriptions-item>
            <el-descriptions-item label="购物积分">{{userForm.ji_fen_lv}}</el-descriptions-item>
            <el-descriptions-item label="金豆余额">{{userForm.shi_fang_jin_dou}}</el-descriptions-item>
            <el-descriptions-item label="助企积分">{{userForm.ji_fen_hong}}</el-descriptions-item>
            <el-descriptions-item label="银豆余额">{{userForm.yin_dou}}</el-descriptions-item>
            <el-descriptions-item label="积分奖励">{{userForm.ji_fen}}</el-descriptions-item>
            <el-descriptions-item label="礼包余额">{{userForm.li_bao}}</el-descriptions-item>
            <el-descriptions-item label="复购积分">{{userForm.ji_fen_fu_gou}}</el-descriptions-item>
            <el-descriptions-item label="铜豆余额">{{userForm.tong_dou}}</el-descriptions-item>
        </el-descriptions>
        <el-table v-if="type == 5" ref="parentUserRef" :data="userForm.parent_user_list" highlight-current-row stripe height="calc( 100% - 40px )" :cell-style="{color:'#515a6e',borderColor:'#E8EAEC'}" :header-cell-style="{background:'#F8F8F9',color:'#515A6E'}">
            <el-table-column prop="user_num" label="用户编号" show-overflow-tooltip></el-table-column>
            <el-table-column prop="nickname" label="昵称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="vip_level_name" label="会员级别" show-overflow-tooltip></el-table-column>
        </el-table>
        <!-- 分页 -->
        <div v-if="type!=1 && type != 5" class="paging">
            <el-pagination @current-change="currentChange" @size-change="sizeChange" :current-page="curr" :page-size="row" background layout="total, sizes, prev, pager, next, jumper" :total="count"></el-pagination>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            userForm: {},
            list: [],

            curr: 1, //页码
            row: 10, //每页条数
            pages: 1, //总页数
            count: 0, //总条数
            total: 0,

            type: '1',
            tabId: '0',
            title: '个人详细信息',
        }
    },
    mounted() {
        this.getUser();
        // this.getList();
    },
    methods: {
        //个人信息
        getUser: function() {
            this.http.post('/admin/user/getInfo', {
                user_id: this.$route.query.id
            }).then(res => {
                this.userForm = res;
            })
        },

        getList() {
            let url = this.tabId == 1 ? '/admin/bill/consumption' : this.tabId == 2 ? '/admin/UserJiFen/indexShareProfit' : '/admin/bill/withdrawal';
            this.http.post(url, {
                curr: this.curr,
                row: this.row,
                user_id: this.$route.query.id
            }).then(res => {
                this.list = res.list;
                this.curr = res.curr;
                this.pages = res.pages;
                this.count = res.count;
                this.total = res.total;
            });
        },

        exportFun: function() {
            this.$confirm(`确定导出订单吗?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                let type = this.tabId == 1 ? 'consumption' : this.tabId == 2 ? 'distribution' : this.tabId == 3 ? 'withdrawal' : ''
                var url = `/admin/bill/excel?param={"user_id":"${this.$route.query.id}","type":"${type}"}`;
                location.href = this.domain + url;
            }).catch(() => {
                this.$message('已取消当前操作');
            })
        },

        success: function() {
            this.$emit('success');
        },

        //切换tab
        handleClick: function(tab) {
            this.list = [];
            this.curr = 1;
            this.title = tab.index == 0 ? '详细身份登记' : tab.index == 1 ? '消费记录' : tab.index == 2 ? '分销结算' : tab.index == 3 ? '提现记录' : '上级列表' ;
            this.tabId = tab.index;
            tab.index == 1 ? this.getList(2) : tab.index == 2 ? this.getList(3) : tab.index == 3 ? this.getList(4) : '';
        },

        //翻页
        currentChange: function(curr) {
            this.curr = curr;
            this.getList();
        },

        //改变每页条数
        sizeChange: function(row) {
            this.row = row;
            this.getList();
        },
        //返回
        goBack: function() {
            this.$router.go(-1)
        }
    }
}
</script>
<style lang="less">
.userLabel {
    width: 200px;
}
.userContent {
    width: calc((100vw - 400px) / 2) !important;
}
.tabSwitch {
    background: #fff;
    margin-bottom: 0;
    .el-tabs__header {
        margin-bottom: 0 !important;
    }
}
</style>
